"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripMarkTags = void 0;
function stripMarkTags(html) {
    if (!html) {
        return html;
    }
    return html.replace(/\<\/?mark\>/g, '');
}
exports.stripMarkTags = stripMarkTags;
//# sourceMappingURL=stripMarkTags.js.map